/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconChevronLeft from './nav-icon-chevron-left.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconChevronLeft {...validProps} />;
}
SvgComponent.iconName = 'navIconChevronLeft';

export const NavIconChevronLeftIcon = svgIconWrapper(SvgComponent);
